// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"f78f60cb","605":"1dd8037e","2134":"972fbaf9","3505":"73435294","6347":"7f2853b0","6773":"34928591","9084":"f78f60cb"}[chunkId] + ".chunk.css";
};